module.exports = __webpack_public_path__ + "img/influence_inc.638c280c.png";